export default function ProductImages() {
	// Re-initialize WooCommerce gallery when variation changes
	jQuery(document).on(
		"found_variation",
		".variations_form",
		function (event, variation) {
			if (variation && variation.image && variation.image.src) {
				// Find the slide with the matching image
				const $gallery = jQuery(".woocommerce-product-gallery");

				const $slides = $gallery.find(
					".woocommerce-product-gallery__image",
				);
				let targetSlideIndex = 0;

				if ($slides.length <= 1) return;

				$slides.each(function (index) {
					const $img = jQuery(this).find("img");
					const imgSrc = $img.attr("src");
					const imgSrcset =
						$img.attr("data-large_image") || $img.attr("src");

					// Check if this slide matches the variation image
					if (
						imgSrc === variation.image.src ||
						imgSrcset === variation.image.full_src
					) {
						targetSlideIndex = index;
						return false; // Break the loop
					}
				});

				// Navigate to the correct slide
				const $flexslider = $gallery.find(".flex-viewport").parent();
				if ($flexslider.length && $flexslider.data("flexslider")) {
					$flexslider.flexslider(targetSlideIndex);
				} else {
					// Alternative for other slider types
					const $owlCarousel = $gallery.find(".owl-carousel");
					if (
						$owlCarousel.length &&
						$owlCarousel.data("owl.carousel")
					) {
						$owlCarousel.trigger("to.owl.carousel", [
							targetSlideIndex,
							300,
						]);
					} else {
						// Fallback for custom sliders - trigger click on thumbnail
						const $thumbs = jQuery(
							".flex-control-thumbs li, .woocommerce-product-gallery__trigger",
						);
						if ($thumbs.length > targetSlideIndex) {
							$thumbs.eq(targetSlideIndex).trigger("click");
						}
					}
				}
			}
		},
	);

	// Reset to first slide when variation is cleared
	jQuery(document).on("reset_data", ".variations_form", function () {
		const $gallery = jQuery(".woocommerce-product-gallery");
		const $slides = $gallery.find(".woocommerce-product-gallery__image");

		if ($slides.length <= 1) return;

		// Navigate to first slide
		const $flexslider = $gallery.find(".flex-viewport").parent();
		if ($flexslider.length && $flexslider.data("flexslider")) {
			$flexslider.flexslider(0);
		} else {
			// Alternative for other slider types
			const $owlCarousel = $gallery.find(".owl-carousel");
			if ($owlCarousel.length && $owlCarousel.data("owl.carousel")) {
				$owlCarousel.trigger("to.owl.carousel", [0, 300]);
			} else {
				// Fallback for custom sliders
				const $firstThumb = jQuery(
					".flex-control-thumbs li, .woocommerce-product-gallery__trigger",
				).first();
				if ($firstThumb.length) {
					$firstThumb.trigger("click");
				}
			}
		}
	});

	// Store original slide position on page load
	jQuery(document).ready(function () {
		const $gallery = jQuery(".woocommerce-product-gallery");
		const $slides = $gallery.find(".woocommerce-product-gallery__image");

		if ($slides.length <= 1) return;

		$gallery.data("original-slide", 0);
	});
}
